import { createContext, useContext, useState, useCallback, type ReactNode, createElement } from 'react'

type Dict = Record<string, string>
type Lang = 'fr' | 'en'

const FR: Dict = {
  appName: 'KayTech',
  appSub: 'Tableau de bord agents',
  nav_overview: 'Vue d’ensemble',
  nav_timeline: 'Journal',
  nav_kanban: 'Kanban',
  nav_compare: 'Comparer',
  nav_charts: 'Évolution',
  nav_diff: 'Diff git',
  nav_settings: 'Paramètres',
  period: 'Période',
  p_today: 'Aujourd’hui',
  p_week: 'Semaine',
  p_month: 'Mois',
  p_quarter: 'Trimestre',
  p_custom: 'Personnalisé',
  search: 'Rechercher dans les rapports…',
  filters: 'Filtres',
  export: 'Exporter',
  export_pdf: 'Exporter PDF',
  export_csv: 'Exporter CSV',
  mark_read: 'Marquer lu',
  compare_period: 'Comparer périodes',
  health: 'Santé',
  h_good: 'Sain',
  h_warning: 'Attention',
  h_critical: 'Critique',
  projects: 'Projets',
  actions: 'Actions',
  errors: 'Erreurs',
  inprogress: 'En cours',
  completed: 'Terminées',
  success_rate: 'Taux de réussite',
  time_spent: 'Temps agent',
  files_mod: 'Fichiers modifiés',
  commits: 'Commits',
  trend: 'Tendance',
  vs_prev: 'vs période préc.',
  current_task: 'Tâche en cours',
  last_activity: 'Dernière activité',
  agent: 'Agent',
  branch: 'Branche',
  open: 'Ouvrir',
  alerts: 'Alertes',
  critical_alert: 'Erreurs critiques détectées',
  view_all: 'Voir tout',
  activity: 'Activité',
  recent_events: 'Événements récents',
  todo_inprogress: 'En cours',
  todo_done: 'Terminé',
  todo_errors: 'Erreurs',
  chart_actions: 'Actions',
  chart_errors: 'Erreurs',
  chart_done: 'Terminées',
  rep_summary: 'Résumé auto',
  project: 'Projet',
  type: 'Type',
  severity_critical: 'critique',
  severity_high: 'élevée',
  severity_medium: 'moyenne',
  severity_low: 'faible',
  new_since: 'Nouveau depuis',
  ago_min: 'min',
  ago_h: 'h',
  chart_type: 'Type de graphique',
  chart_line: 'Ligne',
  chart_bar: 'Barres',
  chart_area: 'Aire',
  connected: 'Connecté à Claude Code',
  syncing: 'Synchronisation auto · toutes les 30 s',
  next_sync: 'Prochaine sync',
  foot: 'Lecture des rapports depuis ~/.claude/projects/*/reports',
  no_data: 'Aucune donnée',
  loading: 'Chargement…',
  error_fetch: 'Erreur de chargement',
  retry: 'Réessayer',
  shortcuts: 'Raccourcis clavier',
  close: 'Fermer',
  theme_dark: 'Sombre',
  theme_light: 'Clair',
  lang_toggle: 'EN',
  no_alerts: 'Aucune alerte active',
  all_projects: 'Tous les projets',
  all_types: 'Tous les types',
  nav_progress: 'Avancement',
  nav_tasks: 'Tâches',
  nav_tokens: 'Tokens',
  reset_prefs: 'Réinitialiser les préférences',
  notif_enable: 'Activer les notifications',
  notif_disable: 'Désactiver les notifications',
  tok_loading: 'Chargement…',
  tok_error: 'Erreur de chargement du budget tokens.',
  tok_consumed: 'Tokens consommés',
  tok_estimated: 'Budget estimé',
  tok_usage: 'Utilisation globale',
  tok_project: 'Projet',
  tok_pct: '%',
  tok_token_usage: 'Utilisation tokens',
  tok_no_budget: 'Pas de BUDGET_TOKENS.md',
  tok_tasks: 'Avancement tâches',
  status_section: 'Statut projets',
  status_all: 'Tous',
  status_active: 'Projets actifs',
  status_waiting: 'Projets en attente',
  status_stopped: 'Projets en arrêt',
  status_done: 'Projets terminés',
}

const EN: Dict = {
  appName: 'KayTech',
  appSub: 'Agents dashboard',
  nav_overview: 'Overview',
  nav_timeline: 'Timeline',
  nav_kanban: 'Kanban',
  nav_compare: 'Compare',
  nav_charts: 'Evolution',
  nav_diff: 'Git diff',
  nav_settings: 'Settings',
  period: 'Period',
  p_today: 'Today',
  p_week: 'Week',
  p_month: 'Month',
  p_quarter: 'Quarter',
  p_custom: 'Custom',
  search: 'Search reports…',
  filters: 'Filters',
  export: 'Export',
  export_pdf: 'Export PDF',
  export_csv: 'Export CSV',
  mark_read: 'Mark read',
  compare_period: 'Compare periods',
  health: 'Health',
  h_good: 'Healthy',
  h_warning: 'Watch',
  h_critical: 'Critical',
  projects: 'Projects',
  actions: 'Actions',
  errors: 'Errors',
  inprogress: 'In progress',
  completed: 'Completed',
  success_rate: 'Success rate',
  time_spent: 'Agent time',
  files_mod: 'Files modified',
  commits: 'Commits',
  trend: 'Trend',
  vs_prev: 'vs prev. period',
  current_task: 'Current task',
  last_activity: 'Last activity',
  agent: 'Agent',
  branch: 'Branch',
  open: 'Open',
  alerts: 'Alerts',
  critical_alert: 'Critical errors detected',
  view_all: 'View all',
  activity: 'Activity',
  recent_events: 'Recent events',
  todo_inprogress: 'In progress',
  todo_done: 'Done',
  todo_errors: 'Errors',
  chart_actions: 'Actions',
  chart_errors: 'Errors',
  chart_done: 'Completed',
  rep_summary: 'Auto summary',
  project: 'Project',
  type: 'Type',
  severity_critical: 'critical',
  severity_high: 'high',
  severity_medium: 'medium',
  severity_low: 'low',
  new_since: 'New since',
  ago_min: 'min',
  ago_h: 'h',
  chart_type: 'Chart type',
  chart_line: 'Line',
  chart_bar: 'Bars',
  chart_area: 'Area',
  connected: 'Connected to Claude Code',
  syncing: 'Auto-sync · every 30s',
  next_sync: 'Next sync',
  foot: 'Reading reports from ~/.claude/projects/*/reports',
  no_data: 'No data',
  loading: 'Loading…',
  error_fetch: 'Load error',
  retry: 'Retry',
  shortcuts: 'Keyboard shortcuts',
  close: 'Close',
  theme_dark: 'Dark',
  theme_light: 'Light',
  lang_toggle: 'FR',
  no_alerts: 'No active alerts',
  all_projects: 'All projects',
  all_types: 'All types',
  nav_progress: 'Progress',
  nav_tasks: 'Tasks',
  nav_tokens: 'Tokens',
  reset_prefs: 'Reset preferences',
  notif_enable: 'Enable notifications',
  notif_disable: 'Disable notifications',
  tok_loading: 'Loading…',
  tok_error: 'Error loading token budget.',
  tok_consumed: 'Tokens consumed',
  tok_estimated: 'Estimated budget',
  tok_usage: 'Global usage',
  tok_project: 'Project',
  tok_pct: '%',
  tok_token_usage: 'Token usage',
  tok_no_budget: 'No BUDGET_TOKENS.md',
  tok_tasks: 'Tasks progress',
  status_section: 'Project status',
  status_all: 'All',
  status_active: 'Active projects',
  status_waiting: 'On hold',
  status_stopped: 'Stopped projects',
  status_done: 'Completed projects',
}

const DICTS: Record<Lang, Dict> = { fr: FR, en: EN }

interface I18nCtx {
  lang: Lang
  t: (key: string) => string
  toggleLang: () => void
  formatDate: (iso: string) => string
  formatTime: (iso: string) => string
}

const I18nContext = createContext<I18nCtx>({
  lang: 'fr',
  t: (k) => k,
  toggleLang: () => {},
  formatDate: (s) => s,
  formatTime: (s) => s,
})

export function I18nProvider({ children, initial = 'fr' }: { children: ReactNode; initial?: Lang }) {
  const [lang, setLang] = useState<Lang>(initial)

  const t = useCallback(
    (key: string): string => DICTS[lang][key] ?? key,
    [lang]
  )

  const toggleLang = useCallback(() => {
    setLang((l) => {
      const next: Lang = l === 'fr' ? 'en' : 'fr'
      localStorage.setItem('cc-lang', next)
      return next
    })
  }, [])

  const formatDate = useCallback(
    (iso: string) =>
      new Intl.DateTimeFormat(lang === 'fr' ? 'fr-FR' : 'en-US', {
        day: '2-digit', month: 'short', year: 'numeric',
      }).format(new Date(iso)),
    [lang]
  )

  const formatTime = useCallback(
    (iso: string) =>
      new Intl.DateTimeFormat(lang === 'fr' ? 'fr-FR' : 'en-US', {
        hour: '2-digit', minute: '2-digit', second: '2-digit',
      }).format(new Date(iso)),
    [lang]
  )

  return createElement(I18nContext.Provider, { value: { lang, t, toggleLang, formatDate, formatTime } }, children)
}

export function useI18n(): I18nCtx {
  return useContext(I18nContext)
}

export function useT(): (key: string) => string {
  return useContext(I18nContext).t
}
